export enum Permission {
  ScanAndPay = 'scan_and_pay.modify',
}
